<template>
  <b-container fluid>
    <b-row>
      <b-col lg="6" offset-lg="3">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">New company</h4>
          </template>
          <template v-slot:body>
            <CompanyFormCreate v-on:company-created="handleCompanyCreated" />
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { core } from "../../config/pluginInit";
import CompanyFormCreate from "./Components/CompanyFormCreate.vue";

export default {
  name: "CompaniesCreate",
  components: {
    CompanyFormCreate
  },
  methods: {
    handleCompanyCreated(e) {
      console.log("handleCompanyCreated received event:", e);
    }
  },
  mounted() {
    core.index();
  }
};
</script>
